import { Component, OnInit } from '@angular/core';
import { Register } from '../../shared/user.model';
import { NgForm } from '@angular/forms';
import { UserService } from '../../shared/user.service';
import { Router } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';
import swal from 'sweetalert2';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {
  register: any = {};
  formSubmitted: boolean;
  data: any;
  districtlist: any;
  statelist: any;
  title = "User Registration";
  user: any = {};
  date: any;
  Show:any="N";
  numericpattern = "^[0-9]*$";
  emailpattern = "^[a-zA-Z0-9._%-+]+@[a-z0-9.-]+\.[a-z]{2,3}$";
  
 // dt = new Date();
  constructor(private userService: UserService, private errorHandler: ErrorHandler, private router: Router) {
    this.formSubmitted = false;
    //this.register = new Register();
  }

  ngOnInit() {
    debugger
    this.GetAllState();
    //this.date = this.add_months(this.dt, 3)

  }

  // add_months(dt, n) {

  //   return new Date(dt.setMonth(dt.getMonth() + n));
  // }

  GetAllState() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetAllStates();
    this.data.subscribe(
      (response: any) => {
        this.statelist = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetAllDistrictById(ID: any) {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetAllDistrictById(ID);
    this.data.subscribe(
      (response: any) => {
        this.districtlist = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });

  }

  onSubmit(form: NgForm,register:any) {
    debugger
    if (!form.invalid) {
      form.value.RoleId = "e70aa274-04ba-485f-b54f-f0f3e6068c72"
      form.value.OfficeId = "1"
      form.value.UserName = form.value.REG_EmailId;
      form.value.OTP = form.value.REG_OTP;
      form.value.Password = form.value.REG_Password;
      form.value.ConfirmPassword = form.value.REG_Confirm_Password;
       form.value.Registration=register;
      document.getElementById('loader-spinner').style.display = "block";
      console.log(form.value);
      this.data = this.userService.registerCustomer(form.value);
      this.data.subscribe(
        (response) => {
          document.getElementById('loader-spinner').style.display = "none";
          swal('', 'Registered Successfully!', 'success');
          this.router.navigate(['/login']);
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
    } else
      this.formSubmitted = true;
  }

  Verify(Mob_No:any){
    debugger
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.VerifyMobileNo(Mob_No);
    this.data.subscribe(
      (response: any) => {
        this.Show = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        swal('', error.error.Message, 'warning');
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/registration/signup/signup.component.ts